import fetch from "unfetch";
import { init } from "@livechat/livechat-visitor-sdk";
import {
  call,
  takeEvery,
  takeLatest,
  fork,
  select,
  put,
  take,
  all
} from "redux-saga/effects";
import { getChatService, getPreForm } from "../reducers/app";
import {
  newMessage,
  newUser,
  ownDataReceived,
  chatEnded,
  chatStarted,
  changeChatService,
  sendMessage,
  chatRated,
  changeChatScreen,
  updateNumberInQueue,
  sendPreForm
} from "../actions/chatActions";
import * as actionTypes from "../constants/chatActionTypes";
import { getEvents } from "../reducers/events";
import { getUsers, getOwnId } from "../reducers/users";
import { PREFORM, POSTFORM } from "../constants/livechatForms";
import chatScreens from "../constants/chatScreens";
import { language } from "../utils/translations";
import configureStore from "../store";
const delay = ms => new Promise(res => setTimeout(res, ms));

const botEngineClientToken = process.env.REACT_APP_BOTENGINE_CLIENT_TOKEN;
const sessionId = String(Math.random());
var counter = 0;
const sendQueryToBotEngine = query =>
  fetch("https://localhost:44348/api/LiveChat/MessageHandler", {
    // bot botbuilder.labiba.ai //https://localhost:44348/api/LiveChat/MessageHandler
    headers: {
      authorization: `Bearer ${botEngineClientToken}`,
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify({
      sessionId: sessionId,
      query: query,
      storyId: process.env.REACT_APP_BOTENGINE_STORY_ID
    })
  }).then(response => response.json().catch(e => console.log("failed", e)));

function strip(html) {
  var doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}

function* transferToLiveChat() {
  const events = yield select(getEvents);
  const users = yield select(getUsers);
  const ownId = yield select(getOwnId);
  const preForm = yield select(getPreForm);
  const parsedEvents = events
    .map(event => {
      const userName =
        (users[event.authorId] && users[event.authorId].name) ||
        users[ownId].name;
      const text = event.text || event.title || event.post;
      return `${userName}: ${text}`;
    })
    .map(strip)
    .join(" \n");
  yield put(sendPreForm(preForm));
  yield put(
    changeChatService({
      chatService: "LiveChat"
    })
  );
  yield put(
    sendMessage({
      customId: "VISITOR_CHAT_HISTORY",
      post: `VISITOR_CHAT_HISTORY: ${parsedEvents}`
    })
  );
}

export function* handleSendMessage(sdk, { payload }) {
  console.log("handleMessage", { id: payload.customId });
  const chatService = yield select(getChatService);
  if (chatService === "LiveChat") {
    try {
      if (payload.post != undefined) {
        yield call(sdk.sendMessage, {
          customId: payload.customId,
          text: payload.post
        });
      } else {
        yield call(sdk.sendMessage, {
          customId: payload.customId,
          text: payload.text
        });
      }
    } catch (error) {
      console.log("> ERROR", error);
    }
    return;
  }
  if (chatService === "botEngine") {
    try {
      const botEngineResponse = yield call(sendQueryToBotEngine, payload.post);
      if (
        !botEngineResponse.result ||
        !botEngineResponse.result.fulfillment ||
        !botEngineResponse.result.fulfillment.length
      ) {
        yield call(transferToLiveChat);
        return;
      }
      const messagesToAdd = botEngineResponse.result.fulfillment.map(
        fulfillmentItem => {
          const message = {
            id: Math.random(),
            authorId: "bot"
          };
          if (fulfillmentItem.message) {
            message.text = fulfillmentItem.message;
          }
          if (fulfillmentItem.buttons) {
            message.buttons = fulfillmentItem.buttons;
          }
          if (fulfillmentItem.title) {
            message.title = fulfillmentItem.title;
          }
          if (fulfillmentItem.imageUrl) {
            message.imageUrl = fulfillmentItem.imageUrl;
          }
          if (fulfillmentItem.replies) {
            message.replies = fulfillmentItem.replies;
          }
          if (botEngineResponse.timestamp) {
            message.timestamp = botEngineResponse.timestamp;
          }
          return newMessage(message);
        }
      );
      console.log({ messagesToAdd });
      yield all(messagesToAdd.map(action => put(action)));
      if (
        botEngineResponse.result.interaction.action === "livechat.transfer.once"
      ) {
        yield call(transferToLiveChat);
      } else {
        if (
          botEngineResponse.result.interaction.action === "livechat.transfer"
        ) {
          if (counter == 2) {
            yield call(transferToLiveChat);
            counter = 0;
          } else {
            counter += 1;
          }
        }
      }
    } catch (error) {
      console.log(">> BOTENGINEERROR", error);
      yield call(transferToLiveChat);
    }
  }
}

function* handleRateGood(sdk) {
  yield call(sdk.rateChat, {
    rate: "good"
  });
}

function* handleRateBad(sdk) {
  yield call(sdk.rateChat, {
    rate: "bad"
  });
}

function* handleCloseChat(sdk) {
  try {
    yield call(sdk.closeChat);
    yield call(configureStore().persistor.purge);
  } catch (err) {
    console.log("Can not close because", err.reason || err);
  }
}

function* handleSendTranscript(sdk, { payload }) {
  try {
    yield call(sdk.forwardChatTranscript, payload);
  } catch (err) {
    console.log("Can not send because", err.reason || err);
  }
}

function* handleSendPreForm(
  sdk,
  { payload: { name, email, mobile, message } }
) {
  try {
    yield call(sdk.sendPrechatForm, {
      [PREFORM[language].NAME]: name,
      [PREFORM[language].MOBILE]: mobile,
      [PREFORM[language].EMAIL]: email,
      [PREFORM[language].MSG]: message
    });
  } catch (err) {
    console.log("Can not send because", err.reason || err);
  }
}

function* handleSendPostForm(
  sdk,
  { payload: { question1, question2, question3 } }
) {
  yield put(changeChatScreen({ screen: chatScreens.CHAT }));
  yield put(sendMessage({ post: "get started", text: "get started" }));
  try {
    yield call(sdk.sendPostChatForm, {
      [POSTFORM.Q1]: question1,
      [POSTFORM.Q2]: question2,
      [POSTFORM.Q3]: question3
    });
    yield call(sdk.rateChat, {
      rate: question3
    });
  } catch (err) {
    console.log("Can not send because", err);
  }
}

function* handleCallbacks(store) {
  const sdk = init({
    license: process.env.REACT_APP_LIVECHAT_LICENSE
  });
  sdk.on("new_message", data => {
    const userName = (getPreForm(store.getState()) || {}).name || "";
    const replaceWithUserName = text =>
      (text || "").replace("%name%", userName);
    console.log("new_message", { data });
    store.dispatch(
      newMessage({ ...data, text: replaceWithUserName(data.text) })
    );
  });
  sdk.on("agent_changed", data => {
    store.dispatch(newUser(data));
  });
  sdk.on("visitor_data", data => {
    store.dispatch(ownDataReceived(data));
  });
  sdk.on("chat_ended", () => {
    console.log(">chat_ended");
    store.dispatch(
      changeChatService({
        chatService: "botEngine"
      })
    );
    store.dispatch(chatEnded());
    store.dispatch(changeChatScreen({ screen: chatScreens.POSTCHAT }));
  });
  sdk.on("chat_started", data => {
    console.log("chat_started", { data });
    store.dispatch(chatStarted(data));
  });
  sdk.on("status_changed", data => {
    console.log("> status_changed", data);
  });
  sdk.on("visitor_queued", data => {
    store.dispatch(updateNumberInQueue(data));
  });
  sdk.on("typing_indicator", data => {
    console.log("> typing_indicator", data);
  });
  sdk.on("connection_status_changed", data => {
    console.log("> connection_status_changed", data);
  });
  sdk.on("chat_rated", data => {
    store.dispatch(
      chatRated({
        rate: data.rate
      })
    );
  });
  try {
    yield call(sdk.getPrechatForm);
    yield call(sdk.getPostChatForm);
  } catch (e) {
    console.log("e", e);
  }
  try {
    yield takeLatest(actionTypes.SEND_MESSAGE, handleSendMessage, sdk);
    yield takeEvery(actionTypes.RATE_GOOD, handleRateGood, sdk);
    yield takeEvery(actionTypes.RATE_BAD, handleRateBad, sdk);
    yield takeEvery(actionTypes.CLOSE_CHAT, handleCloseChat, sdk);
    yield takeEvery(actionTypes.SEND_TRANSCRIPT, handleSendTranscript, sdk);
    yield takeEvery(actionTypes.SEND_PRE_FORM, handleSendPreForm, sdk);
    yield takeEvery(actionTypes.SEND_POST_FORM, handleSendPostForm, sdk);
  } catch (err) {
    console.log("err", err);
  }
}

export default function*(store) {
  yield fork(handleCallbacks, store);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js